// 초기화 전.
export const INIT_READY = "INIT_READY";

// 초기화 진행중
export const INIT_DOING = "INIT_DOING";

// 초기화 실패
export const INIT_FAIL = "INIT_FAIL";

// 초기화 완료
export const INIT_SUCCESS = "INIT_SUCCESS";


/**
 * Status 객체화
 * @param initialized
 * @param list
 * @returns {{isReady: boolean, isDoing: boolean, isFail: boolean, isSuccess: boolean, isEmpty: boolean}}
 */
export const init = (initialized, list) => {
  let status = {
    isReady: false,
    isDoing: false,
    isFail: false,
    isSuccess: false,
    isEmpty: false,
  };

  // 필수값 체크
  if (initialized == null || initialized == undefined) {
    return status;
  }

  // 대기상태
  if (initialized == INIT_READY) {
    status.isReady = true;
  }

  // 진행중
  if (initialized == INIT_DOING) {
    status.isDoing = true;
  }

  // 실패
  if (initialized == INIT_FAIL) {
    status.isFail = true;
  }

  // 성공 && Empty체크
  if (initialized == INIT_SUCCESS) {
    status.isSuccess = true;
    status.isEmpty = (list && Array.isArray(list) && list.length > 0) ? false : true;
  }

  return status;
};
